interface EmptyStateProps {
  title: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionText, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-movie-2-line text-2xl"></i>
      </div>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>}
      {actionText && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-refresh-line"></i>
          {actionText}
        </button>
      )}
    </div>
  );
}